import * as React from 'react';
import {connect} from 'react-redux';

import {convertToArray} from 'nutshell-core/filter';
import {Routing} from 'nutshell-core/routing';

import {useGetSessionUser} from '../../../core/use-get-session-user';
import {getEventsQueryVariables} from '../../../timeline/graphql/graphql-wrappers/helpers';
import {useGetTimelineEvents} from '../../../timeline/graphql/graphql-wrappers/use-get-timeline-events';
import {useDeleteEvent} from '../../../timeline/graphql/timeline-event-mutations';
import {Timeline} from '../../../timeline/timeline';

// @ts-expect-error
import * as actions from '../../dashboard-actions';

import {FeedFilters} from './feed-filters';
// @ts-expect-error
import * as selectors from './feed-selectors';

// @ts-expect-error
const mapStateToProps = function (state) {
    return {
        filter: selectors.getFilter(state),
    };
};

// @ts-expect-error
const mapDispatchToProps = (dispatch): DispatchProps => {
    return {
        onFilterUpdate: (filter) => {
            dispatch(actions.updateFeedFilter(filter));
        },
    };
};

type OwnProps = {
    hideFilters?: boolean;
};

type DispatchProps = {
    onFilterUpdate: (newFilter: string) => void;
};

type StateProps = {
    filter: string;
};

type Props = OwnProps & StateProps & DispatchProps;

export function DashboardFeedComponent(props: Props) {
    const deleteEvent = useDeleteEvent();
    const filterBarRef = React.useRef();

    const activeFilters = convertToArray(Routing.deparam(props.filter));

    const queryVariables = getEventsQueryVariables({
        entityId: null,
        activeFilters,
        after: null,
    });

    // @ts-expect-error
    const filterBarHeight = filterBarRef.current ? filterBarRef.current.clientHeight : undefined;

    const {user} = useGetSessionUser();
    const {events, refetchEvents, isLoading, isFirstLoad, error, fetchMoreEvents, hasNextPage} =
        useGetTimelineEvents(queryVariables);

    return (
        <>
            {props.hideFilters ? undefined : (
                <FeedFilters
                    filter={props.filter}
                    onFilterUpdate={props.onFilterUpdate}
                    // @ts-expect-error
                    getFilterBarRef={(ref) => {
                        filterBarRef.current = ref;
                    }}
                />
            )}
            <Timeline
                onDelete={(eventId: string) => deleteEvent({changeLogId: eventId, queryVariables})}
                events={events}
                user={user}
                refetchEvents={refetchEvents}
                isLoading={isLoading}
                isFirstLoad={isFirstLoad}
                error={error}
                onFetchMoreEvents={fetchMoreEvents}
                hasNextPage={hasNextPage}
                isDashboard={true}
                onRemoveAllFilters={() => {
                    props.onFilterUpdate('');
                }}
                filterBarHeight={filterBarHeight}
            />
        </>
    );
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const DashboardFeed = connector(DashboardFeedComponent);
